export default `<svg xmlns:xodm="http://www.corel.com/coreldraw/odm/2003" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 2500 2500" style="enable-background:new 0 0 2500 2500;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1DA2B4;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
</style>
<g id="Layer_x0020_1">
	<g id="_2806038301888">
		<circle class="st0" cx="1250" cy="1250" r="1250"></circle>
		<g>
			<path class="st1" d="M925,415c22-24,54-37,86-37h212c27,0,41,32,22,51L826,876h231l235,249H826l466,499h-282c-33,0-64-14-86-37     l-473-506c-42-45-42-115,0-160l473-506H925z"></path>
			<path class="st1" d="M1575,2085c-22,24-54,37-86,37h-212c-27,0-41-32-22-51l419-447h-231l-235-249h466l-466-499h282     c33,0,64,14,86,37l473,506c42,45,42,115,0,160l-473,506H1575z"></path>
		</g>
	</g>
</g>
</svg>
`;
